import React, { Component } from 'react'
import PhotoEditor from './PhotoEditor'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { registerUser } from '../redux/user/actions'
import { editRoom, getRoom, getRooms } from '../redux/tools/actions'
import logo from '../assets/img/logo.svg'
import { NavLink } from 'react-router-dom'
import randomInt from 'random-int'
import { Motion, spring } from 'react-motion'
import axios from 'axios'
import assign from 'object-assign'
import pick from 'lodash.pick'
import update from 'immutability-helper'

import {
    Layer,
    Raster,
    Tool,
    View,
    Circle,
    Path,
    Rectangle,
    PointText,
} from 'react-paper-bindings'

import '../assets/scss/placeDetector.scss'

import withInitial from '../components/PlaceDetector/hoc/withInitial'
import withHistory from '../components/PlaceDetector/hoc/withHistory'
import withFullscreen from '../components/PlaceDetector/hoc/withFullscreen'
import withTools from '../components/PlaceDetector/hoc/withTools'
import withMoveTool from '../components/PlaceDetector/hoc/withMoveTool'
import withSelectTool from '../components/PlaceDetector/hoc/withSelectTool'
import withPenTool from '../components/PlaceDetector/hoc/withPenTool'
import withFastPenTool from '../components/PlaceDetector/hoc/withFastPenTool'
import withCircleTool from '../components/PlaceDetector/hoc/withCircleTool'
import withRectangleTool from '../components/PlaceDetector/hoc/withRectangleTool'
import withDeleteTool from '../components/PlaceDetector/hoc/withDeleteTool'
import withPerspectiveTool from '../components/PlaceDetector/hoc/withPerspectiveTool'
import withCubeTool from '../components/PlaceDetector/hoc/withCubeTool'
import withDynamicCubeTool from '../components/PlaceDetector/hoc/withDynamicCubeTool'

import Toolbar from '../components/PlaceDetector/Toolbar/Toolbar'
import Menu from '../components/PlaceDetector/Menu/Menu'
import Loader from '../components/PlaceDetector/Loader/Loader'
import Layers from '../components/PlaceDetector/Layers/Layers'
import { saveData } from '../redux/placeDetector/actions'

class PlaceDetector extends Component {
    static propTypes = {
        image: PropTypes.any.isRequired,
        imageWidth: PropTypes.number.isRequired,
        imageHeight: PropTypes.number.isRequired,
        imageSize: PropTypes.number.isRequired,
        initialData: PropTypes.any.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        activeTool: PropTypes.string,
        activeLayer: PropTypes.number,
        data: PropTypes.object.isRequired,
        selectedItem: PropTypes.string,
        fitImage: PropTypes.func.isRequired,
        setTool: PropTypes.func.isRequired,
        selectItem: PropTypes.func.isRequired,
        selectToolKeyDown: PropTypes.func.isRequired,
        selectToolKeyUp: PropTypes.func.isRequired,
        selectToolMouseDown: PropTypes.func.isRequired,
        selectToolMouseDrag: PropTypes.func.isRequired,
        selectToolMouseUp: PropTypes.func.isRequired,
        moveToolMouseDown: PropTypes.func.isRequired,
        moveToolMouseDrag: PropTypes.func.isRequired,
        moveToolMouseUp: PropTypes.func.isRequired,
        moveToolMouseWheel: PropTypes.func.isRequired,
        penToolMouseDown: PropTypes.func.isRequired,
        penToolMouseDrag: PropTypes.func.isRequired,
        penToolMouseUp: PropTypes.func.isRequired,
        circleToolMouseDown: PropTypes.func.isRequired,
        rectangleToolMouseDown: PropTypes.func.isRequired,
        deleteToolMouseDown: PropTypes.func.isRequired,
        perspectiveItem: PropTypes.func,
    }

    constructor(props) {
        super(props)
        this.state = {
            imageLoaded: false,
            loaded: false,
            showLayers: true,
            size: [randomInt(40, 320), randomInt(40, 320)],
            open: false,
        }

        this._view = null
    }

    save = () => {
        const data = JSON.parse(window.localStorage.getItem('rooms'))
        const roomId = this.props.match.params.id
        let roomIndex
        data.rooms.forEach((element, index) => {
            if (element.id == roomId) {
                roomIndex = index
            }
        })
        const newRooms = update(data, {
            rooms: {
                [roomIndex]: { $set: this.props.data },
            },
        })

        window.localStorage.setItem('rooms', JSON.stringify(newRooms))

        this.setState({ imageLoaded: false, loaded: false })

        setTimeout(() => {
            this.setState({ imageLoaded: true, loaded: true })
        }, 500)
        this.props.saveData(roomId, this.props.data.layers)

        // console.log(JSON.stringify(this.props.data));
        // const json = this._view.scope.project.exportJSON();
        // const svg = this._view.scope.project.exportSVG({ embedImages: false });
    }

    toggleLayers = () => {
        this.setState({
            showLayers: !this.state.showLayers,
        })
    }

    imageLoaded = (image) => {
        this._loaded = true
        this.props.fitImage(image)
        this.setState({ imageLoaded: true, loaded: true })
    }

    updateFinalData = (data) => {
        this.setState({ finalData: data })
    }

    componentDidUpdate(nextProps) {
        const { image } = this.props
        if (image !== nextProps.image) {
            this.setState({ imageLoaded: false })
        }
    }

    render = () => {
        const {
            activeTool,
            activeLayer,
            image,
            data,
            selectedItem,
            selectedItems,
            setTool,
            width,
            height,
        } = this.props

        const { loaded, imageLoaded, showLayers } = this.state

        const toolbarProps = assign(
            pick(this.props, [
                'data',
                'activeTool',
                'animate',
                'fullscreen',
                'imageSize',
                'canUndo',
                'canRedo',
                'photoEditorHandler',
                'stateCubeHandler',
                'stateDynamicCubeHandler',
                'applyCubeSkewChange',
                'confirmCubeHandler',
                'confirmDynamicCubeHandler',
                'deleteCubeHandler',
                'deleteDynamicCubeHandler',
                'getInitialCubeSkewAngle',
                'showCube',
                'showDynamicCube',
                'undo',
                'redo',
                'clearHistory',
                'setTool',
                'toggleAnimation',
                'toggleFullscreen',
                'selectedItem',
                'isSaving',
                'savingError',
                'setDefaultView',
                'perspectiveType',
            ]),
            {
                showLayers,
                save: this.save,
                toggleLayers: this.toggleLayers,
            }
        )

        const layerProps = {
            data,
            activeLayer,
            selectedItem,
            selectItem: this.props.selectItem,
            setTool: this.props.setTool,
            changeColorItem: this.props.changeColorItem,
            changeLockItem: this.props.changeLockItem,
        }

        const menuProps = {
            activeTool,
            setTool,
            x: width / 2,
            y: height - 40,
            tools: [
                { tool: 'delete', icon: 'delete', title: 'حذف مسیر (D)' },
                { tool: 'pen', icon: 'create', title: 'رسم مسیر (P)' },
                {
                    tool: 'fastPen',
                    icon: 'timeline',
                    title: 'رسم سریع مسیر (P)',
                },
                { tool: 'select', icon: 'touch_app', title: 'انتخاب مسیر (A)' },
                { tool: 'move', icon: 'pan_tool', title: 'جابجایی (V)' },
                // { tool: 'circle', icon: 'add_circle', title: 'رسم دایره (C)' },
                // { tool: 'rectangle', icon: 'add_box', title: 'رسم مستطیل (R)' }
            ],
        }

        const viewProps = assign(
            pick(this.props, ['activeTool', 'activeLayer', 'width', 'height']),
            {
                ref: (ref) => (this._view = ref),
                onWheel: this.props.moveToolMouseWheel,
                matrix: pick(this.props, [
                    'sx',
                    'sy',
                    'tx',
                    'ty',
                    'x',
                    'y',
                    'zoom',
                ]),
            }
        )

        return (
            <React.Fragment>
                <div className={`Paper tool-${activeTool}`}>
                    <Toolbar {...toolbarProps} />
                    {/* {loaded && <Menu {...menuProps} />} */}
                    {!imageLoaded && <Loader color={'orange'} />}
                    {loaded && showLayers && <Layers {...layerProps} />}
                    <View {...viewProps}>
                        <Layer name={'raster'}>
                            <Raster
                                locked
                                source={
                                    data &&
                                    (data.editedImageUrl
                                        ? data.editedImageUrl
                                        : data.image)
                                }
                                onLoad={this.imageLoaded}
                            />
                        </Layer>
                        {data &&
                            data.layers.map(
                                ({ id: layerId, type, children, name }) => {
                                    return (
                                        <Layer
                                            name={name}
                                            key={layerId}
                                            data={{ id: layerId, type }}
                                            visible={imageLoaded}
                                            active={layerId === activeLayer}
                                        >
                                            {children.map(
                                                ({
                                                    id: itemId,
                                                    type: Item,
                                                    ...props
                                                }) => {
                                                    const fillColor =
                                                        'rgb(255,255,255,0.05)'
                                                    return (
                                                        <Item
                                                            key={itemId}
                                                            {...props}
                                                            fillColor={
                                                                fillColor
                                                            }
                                                            data={{
                                                                id: itemId,
                                                                type: Item,
                                                            }}
                                                            selected={
                                                                activeTool ===
                                                                'select'
                                                                    ? selectedItems &&
                                                                      selectedItems.length >
                                                                          0
                                                                        ? selectedItems.includes(
                                                                              itemId
                                                                          )
                                                                        : itemId ===
                                                                              selectedItem ||
                                                                          layerId ===
                                                                              selectedItem
                                                                    : false
                                                            }
                                                            onMouseEnter={(
                                                                e
                                                            ) => {
                                                                if (
                                                                    this.props
                                                                        .activeTool ===
                                                                        'select' &&
                                                                    !this.props
                                                                        .selectedItem
                                                                ) {
                                                                    e.target.fillColor =
                                                                        e.target.strokeColor._canvasStyle
                                                                    e.target.opacity = 0.5
                                                                }
                                                            }}
                                                            onMouseLeave={(
                                                                e
                                                            ) => {
                                                                if (
                                                                    !this.props
                                                                        .selectedItem
                                                                ) {
                                                                    e.target.fillColor = fillColor
                                                                    e.target.opacity = 1
                                                                }
                                                            }}
                                                        />
                                                    )
                                                }
                                            )}
                                        </Layer>
                                    )
                                }
                            )}

                        <Tool
                            activeTool={activeTool}
                            active={activeTool === 'move'}
                            name={'move'}
                            onMouseDown={this.props.moveToolMouseDown}
                            onMouseDrag={this.props.moveToolMouseDrag}
                            onMouseUp={this.props.moveToolMouseUp}
                        />
                        <Tool
                            activeTool={activeTool}
                            active={activeTool === 'select'}
                            name={'select'}
                            onKeyDown={this.props.selectToolKeyDown}
                            onKeyUp={this.props.selectToolKeyUp}
                            onMouseDown={this.props.selectToolMouseDown}
                            onMouseDrag={this.props.selectToolMouseDrag}
                            onMouseUp={this.props.selectToolMouseUp}
                            onMouseEnter={this.props.selectToolMouseEnter}
                        />
                        <Tool
                            activeTool={activeTool}
                            active={activeTool === 'pen'}
                            name={'pen'}
                            onMouseDown={this.props.penToolMouseDown}
                            onMouseDrag={this.props.penToolMouseDrag}
                            onMouseUp={this.props.penToolMouseUp}
                            onKeyUp={this.props.penToolKeyUp}
                        />
                        <Tool
                            activeTool={activeTool}
                            active={activeTool === 'fastPen'}
                            name={'fastPen'}
                            onMouseDown={this.props.fastPenToolMouseDown}
                            onMouseMove={this.props.fastPenToolMouseMove}
                            onKeyUp={this.props.fastPenToolKeyUp}
                        />
                        <Tool
                            activeTool={activeTool}
                            active={activeTool === 'circle'}
                            name={'circle'}
                            onMouseDown={this.props.circleToolMouseDown}
                        />
                        <Tool
                            activeTool={activeTool}
                            active={activeTool === 'rectangle'}
                            name={'rectangle'}
                            onMouseDown={this.props.rectangleToolMouseDown}
                        />
                        <Tool
                            activeTool={activeTool}
                            active={activeTool === '2d'}
                            name={'2d'}
                            onMouseDown={this.props.perspectiveToolMouseDown}
                        />
                        <Tool
                            activeTool={activeTool}
                            active={activeTool === 'delete'}
                            name={'delete'}
                            onMouseDown={this.props.deleteToolMouseDown}
                        />
                    </View>
                    {this.props.showCube && this.props.cubeGenerator()}
                    {this.props.showDynamicCube &&
                        this.props.dynamicCubeGenerator()}
                </div>
                {this.props.showPhotoEditor && (
                    <div className={'photo-editor'}>
                        <PhotoEditor
                            isMaterial={false}
                            onUpdate={(file) => {
                                const roomId = this.props.match.params.id
                                this.props.editRoom(roomId, file)
                                this.props.photoEditorHandler()
                            }}
                            image={data.image}
                            onClose={this.props.photoEditorHandler}
                        />
                    </div>
                )}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        loading: store.placeDetector.loading,
        error: store.placeDetector.error,
        isSaving: store.placeDetector.isSaving,
        savingError: store.placeDetector.savingError,
        room: store.tools.room,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        registerUser: (email, password, firstName, lastName, mobile, history) =>
            dispatch(
                registerUser(
                    email,
                    password,
                    firstName,
                    lastName,
                    mobile,
                    history
                )
            ),
        saveData: (roomId, data) => dispatch(saveData(roomId, data)),
        editRoom: (roomId, file) => dispatch(editRoom(roomId, file)),
        getRoom: (id) => dispatch(getRoom(id)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    compose(
        withInitial,
        withHistory,
        withFullscreen,
        withTools,
        withMoveTool,
        withSelectTool,
        withPerspectiveTool,
        withDynamicCubeTool,
        withCubeTool,
        withPenTool,
        withFastPenTool,
        withCircleTool,
        withRectangleTool,
        withDeleteTool
    )(PlaceDetector)
)
